<template>
    <a-modal v-model="visible" :title="title" :width="width" centered :maskClosable="false" :keyboard="false">
        <a-spin :spinning="loading">
            <a-form class="fun-edit-form" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                <a-row :gutter="[0, 6]">
                    <a-col :span="12">
                        <a-form-item label="序号">
                            <a-input-number ref="xh" v-model="editData.xh" :min="0" style="width:100%" disabled />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="[0, 6]">
                    <a-col :span="12">
                        <a-form-item label="自查内容">
                            <a-input ref="zcnr" v-model="editData.zcnr" />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="[0, 9]">
                    <a-col :span="24">
                        <a-form-item label="自查意见" :label-col="{ span: 3 }" :wrapper-col="{ span: 18 }" required>
                            <a-textarea ref="zcyj" :rows="3" v-model="editData.zcyj" />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="[0, 9]">
                    <a-col :span="24">
                        <a-form-item label="备注" :label-col="{ span: 3 }" :wrapper-col="{ span: 18 }">
                            <a-textarea ref="bz" :rows="3" v-model="editData.bz" />
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
        </a-spin>
        <template v-slot:footer>
            <a-button @click="onClose" style="margin-right:8px;">
                取消
            </a-button>
            <a-button type="primary" :loading="saving || loading" @click="onSave">
                保存
            </a-button>
        </template>
    </a-modal>
</template>

<script>
export default {
    name: "ZcjgAdd",
    props: ["showEdit", "xh", "dataId", "zcjgbid"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 父级菜单下拉列表数据
            tableData: [],
            tableDataLoading: false,
            // 系统功能数据

            // 编辑数据
            editData: {},
            editDataLoading: false,
            isShow_zyxx: false
        };
    },
    computed: {
        title() {
            return this.dataId ? "编辑" : "新增";
        },
        visible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
            }
        },
        width() {
            return 1200;
        },
        loading() {
            return this.tableDataLoading || this.editDataLoading;
        }
    },
    watch: {
        visible: {
            handler(newVal) {
                // 显示编辑窗口时加载数据
                if (newVal) {
                    if (!this.dataId) {
                        // 新增，设置默认值
                        this.editData = {
                            isnew: true,
                            id: this.$FG_util.uuid(),
                            xh: this.xh,
                            zcjgbid: this.zcjgbid
                        };
                    } else {
                        this.loadData();
                    }
                    // 设置光标位置
                    this.$nextTick(() => {
                        this.$refs.xh.focus();
                    });
                }
            },
            immediate: true
        }
    },
    methods: {
        saveEvent_zyxx(val) {
            if (val && val.length > 0) {
                this.editData.zyid = val[0][0].ID;
                this.editData.zybh = val[0][0].ZYBH;
                this.editData.zymc = val[0][0].ZYMC;
            }
        },
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/dwdcgl/dwdc/selectZcjgById",
                    {
                        id: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002").then(() => (this.visible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.visible = false;
                    }
                });
        },
        //保存
        onSave() {
            // 表单校验
            if (!this.editData.zcyj) {
                this.$FG_message.error("P0001", "自查意见").then(() => this.$refs.zcyj.focus());
                return;
            }
            // 保存操作

            this.saving = true;
            this.$FG_http
                .post("./api/main/dwdcgl/dwdc/saveZcjg", {
                    data: this.editData
                })
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        // 返回列表
                        this.visible = false;
                        // 通知父组件数据已更新
                        this.$emit("dataUpdated", this.editData.id);
                    } else {
                        this.$refs.xh.focus();
                    }
                });
        },
        // 取消
        onClose(e) {
            this.visible = false;
        }
    }
};
</script>
